export const decodeJwtExpWithBuffer = (token: string | null, bufferSeconds: number = 0): boolean => {
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const exp = payload.exp;
    const currentTime = Math.floor(Date.now() / 1000);

    // 현재 시간 + 버퍼 시간이 만료 시간보다 작으면 유효
    return exp > currentTime + bufferSeconds;
  } catch {
    return false;
  }
};
